import { Box, Stack, Typography } from '@mui/material';
import { useEventGroup } from 'src/context';

interface Props {
    groupId: string;
}

export default function EventGroupHeader(props: Props) {
    const group = useEventGroup(props.groupId);
    return (
        <Stack direction="row">
            <Box sx={{ width: '100%', mt: 2, mb: 2, px: 2 }}>
                <Typography
                    variant="h3"
                    sx={{
                        textAlign: 'center',
                        fontWeight: 500,
                        fontSize: '2rem',
                        letterSpacing: '-0.01em',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                    }}
                >
                    {group?.name || 'NONE'}
                </Typography>
            </Box>
        </Stack>
    );
}
